import React from 'react'
import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import { OlympicMascots } from '../common/constants/olympicsMascots'
import Slider from '@shared/components/slider'
import useWindowSize from '@shared/hooks/windowSize'
import { PointerRight } from '@shared/components/ctIcons'
import CustomLink from '@shared/components/customLink'

export default function Mascots() {
  const [width] = useWindowSize()
  return width < 480 ? null : (
    <div className={styles.mascotCntr}>
      <div className="widget-title  d-flex justify-content-between align-items-center">
        <h3 className="small-head d-flex align-items-center  mb-0">
          <span>Mascots</span>
        </h3>
        {/* <CustomLink href={allRoutes.cricketSeriesNew} prefetch={false}>
          <a className="theme-text font-bold">{"View All"}</a>
        </CustomLink> */}
      </div>
      {width < 480 ? (
        <Slider nav destroyBelow={1199}>
          {OlympicMascots.map((ele, index) => (
            <CustomLink key={index} href={ele?.sSlug}>
              <div className={`d-flex flex-column align-items-center ${styles.minWidth} ${styles.cursorPointer}`}>
                <div className={styles.circleBg}>
                  <MyImage
                    alt={ele?.title || 'Mascot Image'}
                    src={ele?.image}
                    width={width < 480 ? 100 : ele?.width}
                    height={width < 480 ? 100 : ele?.height}
                  />
                </div>
                <div className="d-flex flex-column align-items-center">
                  <div className={styles.title}>{ele?.title}</div>
                  <div className={`d-flex ${styles.marginTop} align-items-center`}>
                    <div className={styles.link}>{ele?.name}</div>
                    <PointerRight />
                  </div>
                </div>
              </div>
            </CustomLink>
          ))}
        </Slider>
      ) : (
        <div className="d-flex justify-content-between">
          {OlympicMascots.map((ele, index) => (
            <CustomLink className={styles.cursorPointer} key={index} href={ele?.sSlug}>
              <div key={index} className={styles.cursorPointer}>
                <div className={styles.circleBg}>
                  <MyImage
                    alt={ele?.title || 'Mascot Image'}
                    src={ele?.image}
                    width={width < 480 ? 100 : ele?.width}
                    height={width < 480 ? 100 : ele?.height}
                  />
                </div>
                <div className="d-flex flex-column align-items-center">
                  <div className={styles.title}>{ele?.title}</div>
                  <div className={`d-flex ${styles.marginTop} align-items-center`}>
                    <div className={styles.link}>{ele?.name}</div>
                    <PointerRight />
                  </div>
                </div>
              </div>
            </CustomLink>
          ))}
        </div>
      )}
    </div>
  )
}
